import { render } from "./purchase_orders_import.vue?vue&type=template&id=0db2f3ac&scoped=true"
import script from "./purchase_orders_import.vue?vue&type=script&lang=js"
export * from "./purchase_orders_import.vue?vue&type=script&lang=js"

import "./purchase_orders_import.vue?vue&type=style&index=0&id=0db2f3ac&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db2f3ac"]])

export default __exports__